(() => {
  'use strict';
  const root = document.getElementById('wr-registry');
  const template = document.getElementById('gift-registry-welcome');
  if (!root || root.dataset.designEnhanced) return;
  root.dataset.designEnhanced = 'true';
  const content = root.querySelector('.wr-content');
  const brand = root.querySelector('.wr-brand');
  const mark = template?.content.querySelector('.wr-brand-mark');
  if (brand && mark) brand.prepend(mark.cloneNode(true));
  const enhance = () => {
    const login = content.querySelector('.wr-actions a[href^="/account/login?"], .wr-actions a[href^="/customer_authentication/login?"]');
    if (login) {
      login.setAttribute('href', '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search));
    }
    if (!template || content.querySelector('.wr-welcome')) return;
    const start = login || content.querySelector('.wr-actions [data-guest-start]');
    const hero = content.querySelector(':scope > .wr-hero');
    if (!start || !hero) return;
    const fragment = template.content.cloneNode(true);
    fragment.querySelector('.wr-brand-mark').remove();
    const welcome = fragment.querySelector('.wr-welcome');
    const copy = welcome.querySelector('.wr-welcome__copy');
    const actions = start.closest('.wr-actions');
    const help = content.querySelector(':scope > .wr-help');
    copy.append(hero, actions);
    if (help) copy.append(help);
    content.replaceChildren(fragment);
  };
  new MutationObserver(enhance).observe(content, { childList: true });
  enhance();
})();
